'use strict';

var _regeneratorRuntime = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/asyncToGenerator");

Object.defineProperty(exports, '__esModule', {
  value: true
});

var dagPB = require('@ipld/dag-pb');

var hamtSharding = require('hamt-sharding');

var dirSharded = require('./dir-sharded.js');

var debug = require('debug');

var ipfsUnixfs = require('ipfs-unixfs');

var last = require('it-last');

var cid = require('multiformats/cid');

var hamtConstants = require('./hamt-constants.js');

function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}

function _interopNamespace(e) {
  if (e && e.__esModule) return e;
  var n = Object.create(null);

  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function get() {
            return e[k];
          }
        });
      }
    });
  }

  n["default"] = e;
  return Object.freeze(n);
}

var dagPB__namespace = /*#__PURE__*/_interopNamespace(dagPB);

var debug__default = /*#__PURE__*/_interopDefaultLegacy(debug);

var last__default = /*#__PURE__*/_interopDefaultLegacy(last);

var log = debug__default["default"]('ipfs:mfs:core:utils:hamt-utils');

var updateHamtDirectory = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(context, links, bucket, options) {
    var data, node, dir, hasher, parent, buf, hash, cid$1;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (options.parent.Data) {
              _context.next = 2;
              break;
            }

            throw new Error('Could not update HAMT directory because parent had no data');

          case 2:
            data = Uint8Array.from(bucket._children.bitField().reverse());
            node = ipfsUnixfs.UnixFS.unmarshal(options.parent.Data);
            dir = new ipfsUnixfs.UnixFS({
              type: 'hamt-sharded-directory',
              data: data,
              fanout: bucket.tableSize(),
              hashType: hamtConstants.hamtHashCode,
              mode: node.mode,
              mtime: node.mtime
            });
            _context.next = 7;
            return context.hashers.getHasher(options.hashAlg);

          case 7:
            hasher = _context.sent;
            parent = {
              Data: dir.marshal(),
              Links: links.sort(function (a, b) {
                return (a.Name || '').localeCompare(b.Name || '');
              })
            };
            buf = dagPB__namespace.encode(parent);
            _context.next = 12;
            return hasher.digest(buf);

          case 12:
            hash = _context.sent;
            cid$1 = cid.CID.create(options.cidVersion, dagPB__namespace.code, hash);

            if (!options.flush) {
              _context.next = 17;
              break;
            }

            _context.next = 17;
            return context.repo.blocks.put(cid$1, buf);

          case 17:
            return _context.abrupt("return", {
              node: parent,
              cid: cid$1,
              size: links.reduce(function (sum, link) {
                return sum + (link.Tsize || 0);
              }, buf.length)
            });

          case 18:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function updateHamtDirectory(_x, _x2, _x3, _x4) {
    return _ref.apply(this, arguments);
  };
}();

var recreateHamtLevel = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(context, links, rootBucket, parentBucket, positionAtParent) {
    var bucket;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            bucket = new hamtSharding.Bucket({
              hash: rootBucket._options.hash,
              bits: rootBucket._options.bits
            }, parentBucket, positionAtParent);

            parentBucket._putObjectAt(positionAtParent, bucket);

            _context2.next = 4;
            return addLinksToHamtBucket(context, links, bucket, rootBucket);

          case 4:
            return _context2.abrupt("return", bucket);

          case 5:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function recreateHamtLevel(_x5, _x6, _x7, _x8, _x9) {
    return _ref2.apply(this, arguments);
  };
}();

var recreateInitialHamtLevel = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(links) {
    var bucket;
    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            bucket = hamtSharding.createHAMT({
              hashFn: hamtConstants.hamtHashFn,
              bits: hamtConstants.hamtBucketBits
            });
            _context4.next = 3;
            return Promise.all(links.map( /*#__PURE__*/function () {
              var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(link) {
                var linkName, pos, subBucket;
                return _regeneratorRuntime.wrap(function _callee3$(_context3) {
                  while (1) {
                    switch (_context3.prev = _context3.next) {
                      case 0:
                        linkName = link.Name || '';

                        if (!(linkName.length === 2)) {
                          _context3.next = 6;
                          break;
                        }

                        pos = parseInt(linkName, 16);
                        subBucket = new hamtSharding.Bucket({
                          hash: bucket._options.hash,
                          bits: bucket._options.bits
                        }, bucket, pos);

                        bucket._putObjectAt(pos, subBucket);

                        return _context3.abrupt("return", Promise.resolve());

                      case 6:
                        return _context3.abrupt("return", bucket.put(linkName.substring(2), {
                          size: link.Tsize,
                          cid: link.Hash
                        }));

                      case 7:
                      case "end":
                        return _context3.stop();
                    }
                  }
                }, _callee3);
              }));

              return function (_x11) {
                return _ref4.apply(this, arguments);
              };
            }()));

          case 3:
            return _context4.abrupt("return", bucket);

          case 4:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));

  return function recreateInitialHamtLevel(_x10) {
    return _ref3.apply(this, arguments);
  };
}();

var addLinksToHamtBucket = /*#__PURE__*/function () {
  var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(context, links, bucket, rootBucket) {
    return _regeneratorRuntime.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            _context6.next = 2;
            return Promise.all(links.map( /*#__PURE__*/function () {
              var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(link) {
                var linkName, pos, block, node, subBucket;
                return _regeneratorRuntime.wrap(function _callee5$(_context5) {
                  while (1) {
                    switch (_context5.prev = _context5.next) {
                      case 0:
                        linkName = link.Name || '';

                        if (!(linkName.length === 2)) {
                          _context5.next = 13;
                          break;
                        }

                        log('Populating sub bucket', linkName);
                        pos = parseInt(linkName, 16);
                        _context5.next = 6;
                        return context.repo.blocks.get(link.Hash);

                      case 6:
                        block = _context5.sent;
                        node = dagPB__namespace.decode(block);
                        subBucket = new hamtSharding.Bucket({
                          hash: rootBucket._options.hash,
                          bits: rootBucket._options.bits
                        }, bucket, pos);

                        bucket._putObjectAt(pos, subBucket);

                        _context5.next = 12;
                        return addLinksToHamtBucket(context, node.Links, subBucket, rootBucket);

                      case 12:
                        return _context5.abrupt("return", Promise.resolve());

                      case 13:
                        return _context5.abrupt("return", rootBucket.put(linkName.substring(2), {
                          size: link.Tsize,
                          cid: link.Hash
                        }));

                      case 14:
                      case "end":
                        return _context5.stop();
                    }
                  }
                }, _callee5);
              }));

              return function (_x16) {
                return _ref6.apply(this, arguments);
              };
            }()));

          case 2:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6);
  }));

  return function addLinksToHamtBucket(_x12, _x13, _x14, _x15) {
    return _ref5.apply(this, arguments);
  };
}();

var toPrefix = function toPrefix(position) {
  return position.toString(16).toUpperCase().padStart(2, '0').substring(0, 2);
};

var generatePath = /*#__PURE__*/function () {
  var _ref7 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(context, fileName, rootNode) {
    var rootBucket, position, path, currentBucket, _loop, i, _ret;

    return _regeneratorRuntime.wrap(function _callee7$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            _context8.next = 2;
            return recreateInitialHamtLevel(rootNode.Links);

          case 2:
            rootBucket = _context8.sent;
            _context8.next = 5;
            return rootBucket._findNewBucketAndPos(fileName);

          case 5:
            position = _context8.sent;
            path = [{
              bucket: position.bucket,
              prefix: toPrefix(position.pos)
            }];
            currentBucket = position.bucket;

            while (currentBucket !== rootBucket) {
              path.push({
                bucket: currentBucket,
                prefix: toPrefix(currentBucket._posAtParent)
              });
              currentBucket = currentBucket._parent;
            }

            path.reverse();
            path[0].node = rootNode;
            _loop = /*#__PURE__*/_regeneratorRuntime.mark(function _loop(i) {
              var segment, link, block, node, _position, nextSegment;

              return _regeneratorRuntime.wrap(function _loop$(_context7) {
                while (1) {
                  switch (_context7.prev = _context7.next) {
                    case 0:
                      segment = path[i];

                      if (segment.node) {
                        _context7.next = 3;
                        break;
                      }

                      throw new Error('Could not generate HAMT path');

                    case 3:
                      link = segment.node.Links.filter(function (link) {
                        return (link.Name || '').substring(0, 2) === segment.prefix;
                      }).pop();

                      if (link) {
                        _context7.next = 7;
                        break;
                      }

                      log("Link ".concat(segment.prefix).concat(fileName, " will be added"));
                      return _context7.abrupt("return", "continue");

                    case 7:
                      if (!(link.Name === "".concat(segment.prefix).concat(fileName))) {
                        _context7.next = 10;
                        break;
                      }

                      log("Link ".concat(segment.prefix).concat(fileName, " will be replaced"));
                      return _context7.abrupt("return", "continue");

                    case 10:
                      log("Found subshard ".concat(segment.prefix));
                      _context7.next = 13;
                      return context.repo.blocks.get(link.Hash);

                    case 13:
                      block = _context7.sent;
                      node = dagPB__namespace.decode(block);

                      if (path[i + 1]) {
                        _context7.next = 24;
                        break;
                      }

                      log("Loaded new subshard ".concat(segment.prefix));
                      _context7.next = 19;
                      return recreateHamtLevel(context, node.Links, rootBucket, segment.bucket, parseInt(segment.prefix, 16));

                    case 19:
                      _context7.next = 21;
                      return rootBucket._findNewBucketAndPos(fileName);

                    case 21:
                      _position = _context7.sent;
                      path.push({
                        bucket: _position.bucket,
                        prefix: toPrefix(_position.pos),
                        node: node
                      });
                      return _context7.abrupt("return", "continue");

                    case 24:
                      nextSegment = path[i + 1];
                      _context7.next = 27;
                      return addLinksToHamtBucket(context, node.Links, nextSegment.bucket, rootBucket);

                    case 27:
                      nextSegment.node = node;

                    case 28:
                    case "end":
                      return _context7.stop();
                  }
                }
              }, _loop);
            });
            i = 0;

          case 13:
            if (!(i < path.length)) {
              _context8.next = 21;
              break;
            }

            return _context8.delegateYield(_loop(i), "t0", 15);

          case 15:
            _ret = _context8.t0;

            if (!(_ret === "continue")) {
              _context8.next = 18;
              break;
            }

            return _context8.abrupt("continue", 18);

          case 18:
            i++;
            _context8.next = 13;
            break;

          case 21:
            _context8.next = 23;
            return rootBucket.put(fileName, true);

          case 23:
            path.reverse();
            return _context8.abrupt("return", {
              rootBucket: rootBucket,
              path: path
            });

          case 25:
          case "end":
            return _context8.stop();
        }
      }
    }, _callee7);
  }));

  return function generatePath(_x17, _x18, _x19) {
    return _ref7.apply(this, arguments);
  };
}();

var createShard = /*#__PURE__*/function () {
  var _ref8 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(context, contents) {
    var options,
        shard,
        i,
        res,
        _args9 = arguments;
    return _regeneratorRuntime.wrap(function _callee8$(_context9) {
      while (1) {
        switch (_context9.prev = _context9.next) {
          case 0:
            options = _args9.length > 2 && _args9[2] !== undefined ? _args9[2] : {};
            shard = new dirSharded.DirSharded({
              root: true,
              dir: true,
              parent: undefined,
              parentKey: undefined,
              path: '',
              dirty: true,
              flat: false,
              mtime: options.mtime,
              mode: options.mode
            }, options);
            i = 0;

          case 3:
            if (!(i < contents.length)) {
              _context9.next = 9;
              break;
            }

            _context9.next = 6;
            return shard._bucket.put(contents[i].name, {
              size: contents[i].size,
              cid: contents[i].cid
            });

          case 6:
            i++;
            _context9.next = 3;
            break;

          case 9:
            _context9.next = 11;
            return last__default["default"](shard.flush(context.repo.blocks));

          case 11:
            res = _context9.sent;

            if (res) {
              _context9.next = 14;
              break;
            }

            throw new Error('Flushing shard yielded no result');

          case 14:
            return _context9.abrupt("return", res);

          case 15:
          case "end":
            return _context9.stop();
        }
      }
    }, _callee8);
  }));

  return function createShard(_x20, _x21) {
    return _ref8.apply(this, arguments);
  };
}();

exports.addLinksToHamtBucket = addLinksToHamtBucket;
exports.createShard = createShard;
exports.generatePath = generatePath;
exports.recreateHamtLevel = recreateHamtLevel;
exports.recreateInitialHamtLevel = recreateInitialHamtLevel;
exports.toPrefix = toPrefix;
exports.updateHamtDirectory = updateHamtDirectory;